import React from 'react';
import { TextLight } from 'components/Texts';
import {
  colors, weight, Div, Figure,
} from 'globalStyle';
import { routes } from 'routes';
import { useLocation } from 'wouter';
import { capitalizeFirstLetterString } from 'util/capitalizeFirstLetter';
import { getCategoryProject } from 'util/getCategoryProject';
import { formatNumber } from 'util/formatNumber';
import { getTimeLaunch } from 'util/getTimeLaunch';
import moment from 'moment';
import { Countdown } from 'components/Countdown';
import { getContrastTextColor } from 'util/contrast';
import { typesProjectType, colorByProjectType } from 'types/projectType';
import {
  Card,
  CategoryContainer,
  ContainerDetails,
  Content,
  Details,
  ImgContainer,
  NameContainer,
  StatusProject,
  TextName,
  TypeProject,
} from './stylesProjectCard';
import StyledHollow from './StyledHollow';

export const CampaignProjectCard = ({
  projectName,
  companyName,
  category,
  tag,
  from,
  images,
  maxAmount,
  campaignDate,
  details,
  color,
  projectType,
}) => {
  const [, setLocation] = useLocation();
  const imagen = images[0];
  const time = getTimeLaunch(campaignDate);
  const { imageCategory } = getCategoryProject(
    category,
    color || colorByProjectType[projectType],
  );

  const handleClick = () => {
    setLocation(`${routes.project.route}${tag}${from ? `?from=${from}` : ''}`);
  };

  const handleHours = (period) => {
    if (period < 10 && period >= 0) return `0${period}`;
    if (period < 0) return '00';
    return period;
  };

  const renderer = ({ hours, minutes, seconds }) => {
    if (hours < 0 && minutes < 0 && seconds < 0) {
      return (
        <TextLight size={20} weight={weight.BOLD}>
          00:00:00
        </TextLight>
      );
    }
    return (
      <TextLight size={20} weight={weight.BOLD}>
        {`${handleHours(hours)}:${handleHours(minutes)}:${handleHours(
          seconds,
        )}`}
      </TextLight>
    );
  };
  const ProjectDetails = () => (
    <ContainerDetails>
      {details?.map(({ name, value, size }) => (
        <Details key={name} width="100%">
          <TextLight
            size={11}
            isCenter
            weight={weight.MEDIUM}
            color={colors.GRAY_3}
            height="50%"
          >
            {name}
          </TextLight>

          <TextLight
            size={size || 14}
            weight={weight.BOLD}
            isCenter
            height="50%"
          >
            {value}
          </TextLight>
        </Details>
      ))}
    </ContainerDetails>
  );

  const Launch = () => {
    if (time?.missingDays) {
      return (
        <Div
          isFlex
          justify="flex-start"
          height="50px"
          style={{
            borderBottom: `1px solid ${color || colorByProjectType[projectType]}`,
            paddingBottom: '5px',
          }}
        >
          <TextLight
            size={13}
            weight={weight.MEDIUM}
            width="20ch"
            align="end"
            mr={5}
            style={{ height: '43px' }}
          >
            Fecha de lanzamiento:
          </TextLight>
          <Div width="100%">
            <TextLight size={24} weight={weight.BOLD}>
              {`${time?.days} ${time?.days > 1 ? 'días' : 'día'}`}
            </TextLight>
            <TextLight size={13} weight={weight.BOLD}>
              {moment(campaignDate).format('DD MMMM YYYY')}
            </TextLight>
          </Div>
        </Div>
      );
    }
    return (
      <Div
        isFlex
        height="30px"
        margin="0 0 5px"
        padding="0 0 5px"
        style={{
          borderBottom: `1px solid ${color || colorByProjectType[projectType]}`,
          paddingBottom: '5px',
        }}
      >
        <TextLight size={13} weight={weight.MEDIUM} align="end" mr={5}>
          Invierte en:
        </TextLight>
        <Div width="100%">
          <Countdown date={campaignDate} renderer={renderer} />
        </Div>
      </Div>
    );
  };

  return (
    <Card onClick={handleClick}>
      <ImgContainer>
        <StatusProject>
          <TextLight
            size={14}
            color={color || colorByProjectType[projectType]}
            weight={weight.BOLD}
            style={{ fontStyle: 'italic' }}
          >
            Proyecto pre lanzamiento
          </TextLight>
        </StatusProject>
        <TypeProject>{typesProjectType[projectType]}</TypeProject>
        <Div
          style={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${imagen})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            borderRadius: '25px 25px 0 0',
          }}
        />
        <NameContainer
          finalCustomColor={`${color || colorByProjectType[projectType]}78`}
          initialCustomColor={`${color || colorByProjectType[projectType]}8A`}
        >
          <TextName clamp={2} fontWeight={weight.BOLD}>
            {capitalizeFirstLetterString(projectName)}
          </TextName>
          <TextName clamp={1} fontWeight={weight.MEDIUM} margin="5px 0 0">
            {`Por ${capitalizeFirstLetterString(companyName)}`}
          </TextName>
          <CategoryContainer>
            <Figure
              style={{
                width: '60%',
                height: '60%',
                position: 'relative',
                top: '8px',
                left: '8px',
              }}
            >
              {imageCategory}
            </Figure>
          </CategoryContainer>
        </NameContainer>
      </ImgContainer>
      <Content>
        <Launch />
        <TextLight size={13}>
          Meta:
          <span style={{ fontWeight: weight.BOLD, marginLeft: '3px' }}>
            {formatNumber(maxAmount)}
          </span>
        </TextLight>
        <ProjectDetails />

        <Div isFlex>
          <StyledHollow
            href={`${routes.project.route}${tag}`}
            color={colorByProjectType[projectType]}
            style={{
              width: '100px',
              height: '35px',
              padding: '10px 0',
              borderRadius: '20px',
            }}
            size={12}
            borderColor={color}
            customColor={color ? colors.WHITE : undefined}
            textColor={
              color
                && getContrastTextColor(
                  color,
                  { defaultDark: color },
                )
            }
          >
            Más detalles
          </StyledHollow>
        </Div>
      </Content>
    </Card>
  );
};
